import React from 'react';
import PropTypes from 'prop-types';
import { FILTER_IDS } from '@src/js/constants.js';
import { useSearchParams } from 'react-router-dom';
import { SearchFilter } from '@src/components/core/core-component-imports.js';
import useProviderSpecialtiesSearch from '@src/hooks/use-provider-specialties-search.jsx';
import FindAProviderResultsContentType from '@js/content-types/find-a-provider-results-content-type.es6.js';

/**
 * Renders a provider-level search filter for specialty options. Click handlers handled by hooks.
 */
const SpecialtySearchFilter = ({ open, clickHandler }) => {
  const [searchParams] = useSearchParams();
  const search = searchParams.get(FILTER_IDS.SEARCH);

  const findAProviderResults = new FindAProviderResultsContentType();
  const specialtyFilterLabel = findAProviderResults.specialtyFilterLabel.item.$(0).text();
  const applyFilterLabel = findAProviderResults.applyFilterLabel.item.$(0).text();
  const clearLabel = findAProviderResults.clearLabel.item.$(0).text();
  const searchPlaceholder = findAProviderResults.searchPlaceholder.item.$(0).text();

  const { loading, error, response: specialties } = useProviderSpecialtiesSearch({ search, immediate: true });

  const getOptions = () => {
    let options = {};
    specialties?.forEach(specialty => {
      options[specialty] = {
        label: specialty,
      };
    });
    return options;
  };

  const options = getOptions();

  return (
    <SearchFilter
      name={specialtyFilterLabel}
      queryParameterName={FILTER_IDS.SPECIALTY}
      disabled={loading || error}
      options={options}
      open={open}
      clickHandler={clickHandler}
      applyFilterLabel={applyFilterLabel}
      clearLabel={clearLabel}
      searchPlaceholder={searchPlaceholder}
    />
  );
}

SpecialtySearchFilter.propTypes = {
  /**
   *  determines if the filter is active for user selection (when true) or closed (when false)
   */
  open: PropTypes.bool.isRequired,
  /**
   * the callback function for when the filter button is clicked
   */
  clickHandler: PropTypes.func.isRequired,
};

export default SpecialtySearchFilter
